exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".right-box[data-v-3f3022e0] {\n  padding-left: 20px;\n}\n", ""]);

// exports
